import { useState, useEffect, useRef } from "react";
import {
  reportSortOptions,
  reportStatusOptions,
} from "../../SubmitTip/resources";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";

const ReportSort = ({
  type = "sort",
  setSortOption,
  disabled,
  classNames,
}: {
  type?: "sort" | "filter";
  setSortOption: (sortOption: { label: string; value: string } | null) => void;
  disabled: boolean;
  classNames?: string;
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const data =
    type === "filter"
      ? [{ label: "All", value: "" }, ...reportStatusOptions]
      : reportSortOptions;

  const toggleOpen = () => setOpen((prev) => !prev);

  const handleClickAway = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickAway);
    return () => {
      document.removeEventListener("mousedown", handleClickAway);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`relative flex flex-col items-start justify-start gap-1 cursor-pointer ${classNames}`}
    >
      <div
        className={`flex items-center gap-[14px] w-full ${
          disabled ? "cursor-not-allowed" : "cursor-pointer"
        }`}
        onClick={!disabled ? toggleOpen : undefined}
      >
        <span
          className={`rounded-[24px] font-[600] text-base leading-5 ${
            disabled ? "text-gray-3" : "text-gray-7"
          }`}
        >
          {type === "filter" ? "Filter by status" : "Sort by"}
        </span>

        {open ? (
          <FaChevronUp
            className={disabled ? "text-gray-3" : "text-gray-7"}
            size={12}
          />
        ) : (
          <FaChevronDown
            className={disabled ? "text-gray-3" : "text-gray-7"}
            size={12}
          />
        )}
      </div>

      {open && (
        <div className="absolute w-[181px] top-[28px] right-0 z-30 flex flex-col bg-white rounded-[12px] p-2 shadow-selectMenu-status">
          {data.map((option, i) => (
            <div
              className="py-[13px] px-3 text-[14px] leading-4 font-medium hover:bg-gray-2"
              onClick={() => {
                if (disabled) return;
                setSortOption(option);
                setOpen(false);
              }}
              key={i}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReportSort;
